import {
  getVendorStats,
  getVendorDashboard,
  postVendorProperties,
  getTopSellingProperties,
  getTopSellingRooms,
  getVendorPropertyStats,
  getVendorPropertiesTaxesFees,
  getRoomTypes,
  postVendorPropertiesPolicies,
  postVendorPropertyTaxesFees,
  postVendorPropertyServices,
  postVendorPropertyRoom,
  postVendorPropertyRoomImages,
  postVendorPropertiesAmenities,
  getVendorPropertiesAmenities,
  getRoomAmenities,
  postVendorRoomAmenities,
  getVendorProperties,
  getVendorPropertyCompletionStatus,
  getVendorActivePropertyStatus,
  getVendorPropertyTodayActivity,
  setRoomAvailability,
  getPropertyImages,
  postVendorPropertyImages,
  putPropertyImage,
  deletePropertyImage,
  getPropertyAmenitiesDetail,
  getPropertyRoomsList,
  getRoomAmenitiesDetail,
  getVendorProperty,
  putVendorProperty,
  putVendorPropertiesPolicies,
  putVendorPropertiesAmenities,
  putVendorPropertyServices,
  putVendorPropertyTaxesFees,
  putVendorPropertyRoom,
  putVendorRoomAmenities,
} from "./../../helpers/backend_helper";
import {
  getVendorStatsSuccess,
  getVendorDashboardSuccess,
  postVendorPropertiesSuccess,
  apiError,
  setLoading,
  resetVendorFlag,
  resetPropertyCreation,
  getTopSellingPropertiesSuccess,
  getTopSellingRoomsSuccess,
  getVendorPropertyStatsSuccess,
  getVendorPropertyTaxesFeesSuccess,
  getVendorPropertyCompletionStatusSuccess,
  getVendorActiveStatusSuccess,
  postVendorPropertiesAmenitiesSuccess,
  getVendorPropertiesAmenitiesSuccess,
  getRoomAmenitiesSuccess,
  getRoomTypesSuccess,
  postVendorRoomAmenitiesSuccess,
  postVendorPropertiesPoliciesSuccess,
  getAllVendorPropertiesSuccess,
  getVendorPropertySuccess,
} from "./reducer";

export const fetchVendorStats = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));

    const response: any = await getVendorStats();

    if (response && response.success) {
      dispatch(getVendorStatsSuccess(response.data));
    } else {
      dispatch(apiError("Failed to fetch vendor statistics"));
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "An error occurred while fetching vendor statistics";
    dispatch(apiError(errorMessage));
  }
};

export const fetchVendorDashboard = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));

    const response: any = await getVendorDashboard();

    if (response && response.success) {
      dispatch(getVendorDashboardSuccess(response.data));
    } else {
      dispatch(apiError("Failed to fetch vendor dashboard"));
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "An error occurred while fetching vendor dashboard";
    dispatch(apiError(errorMessage));
  }
};

export const fetchTopSellingProperty = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));

    const response: any = await getTopSellingProperties();

    if (response && response.success) {
      dispatch(getTopSellingPropertiesSuccess(response.data));
    } else {
      dispatch(apiError("Failed to fetch properties "));
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "An error occurred while fetching vendor properties";
    dispatch(apiError(errorMessage));
  }
};
export const fetchAllVendorProperty = (params?: Record<string, any>) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));

    const response: any = await getVendorProperties(params);

    if (response && response.success) {
      dispatch(getAllVendorPropertiesSuccess({ data: response.data, meta: response.meta }));
    } else {
      dispatch(apiError("Failed to fetch All properties "));
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "An error occurred while fetching all vendor properties";
    dispatch(apiError(errorMessage));
  }
};

export const fetchTopSellingRoom = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));

    const response: any = await getTopSellingRooms();

    if (response && response.success) {
      dispatch(getTopSellingRoomsSuccess(response.data));
    } else {
      dispatch(apiError("Failed to fetch Room "));
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "An error occurred while fetching vendor Room";
    dispatch(apiError(errorMessage));
  }
};

interface PropertyStatsParams {
  page?: number;
  per_page?: number;
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
  status?: string;
  search?: string;
}

export const fetchVendorPropertyStats = (params?: PropertyStatsParams) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));

    const response: any = await getVendorPropertyStats(params);

    if (response && response.success) {
      dispatch(getVendorPropertyStatsSuccess(response.data));
    } else {
      dispatch(apiError("Failed to fetch properties stats "));
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "An error occurred while fetching vendor properties stats";
    dispatch(apiError(errorMessage));
  }
};

export const fetchVendorPropertyAmenities = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));

    const response: any = await getVendorPropertiesAmenities();

    if (response && response.success) {
      dispatch(getVendorPropertiesAmenitiesSuccess(response.data));
    } else {
      dispatch(apiError("Failed to fetch properties amenities "));
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "An error occurred while fetching vendor properties amenities";
    dispatch(apiError(errorMessage));
  }
};

export const fetchVendorPropertyTaxesFees = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));

    const response: any = await getVendorPropertiesTaxesFees();

    if (response && response.success) {
      dispatch(getVendorPropertyTaxesFeesSuccess(response.data));
    } else {
      dispatch(apiError("Failed to fetch taxes and fees"));
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "An error occurred while fetching taxes and fees";
    dispatch(apiError(errorMessage));
  }
};

export const fetchVendorPropertyCompletionStatus =
  (propertyId: number | string, options?: { silent?: boolean }) => async (dispatch: any) => {
    const silent = options?.silent === true;
    try {
      if (!silent) {
        dispatch(setLoading(true));
      }

      const response: any = await getVendorPropertyCompletionStatus(propertyId);

      if (response && response.success) {
        dispatch(getVendorPropertyCompletionStatusSuccess(response.data));
        return { success: true, data: response.data };
      } else {
        const errorMessage = response?.message || "Failed to fetch property completion status";
        if (!silent) {
          dispatch(apiError(errorMessage));
        }
        return { success: false, error: errorMessage };
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred while fetching property completion status";
      if (!silent) {
        dispatch(apiError(errorMessage));
      }
      return { success: false, error: errorMessage };
    }
  };

// thunk for active property status (used during login)
export const fetchVendorActivePropertyStatus = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const response: any = await getVendorActivePropertyStatus();
    if (response && response.success) {
      // store it in state if needed
      dispatch(getVendorActiveStatusSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMessage = response?.message || "Failed to fetch active property status";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "An error occurred while fetching active property status";
    dispatch(apiError(errorMessage));
    return { success: false, error: errorMessage };
  }
};

export const fetchVendorProperty =
  (propertyId: number | string) => async (dispatch: any) => {
    try {
      const response: any = await getVendorProperty(propertyId);
      if (response?.success) {
        const property = response.data?.property ?? response.data;
        dispatch(getVendorPropertySuccess(property));
        return { success: true, data: property };
      }
      return { success: false, error: response?.message || "Failed to fetch property" };
    } catch (error: any) {
      return { success: false, error: error?.message || "Failed to fetch property" };
    }
  };

export const fetchPropertyImages =
  (propertyId: number | string) => async (_dispatch: any) => {
    try {
      const response: any = await getPropertyImages(propertyId);
      return { success: true, data: response };
    } catch (error: any) {
      return { success: false, error: error?.message || "Failed to fetch property images" };
    }
  };

export const uploadPropertyImages =
  ({ propertyId, files, photoType, tag, roomId }: any) => async (dispatch: any) => {
    try {
      const formData = new FormData();
      files.forEach((file: File, index: number) => {
        formData.append(`images[${index}]`, file);
      });
      if (photoType) formData.append('photo_type', photoType);
      if (tag) formData.append('tag', tag);

      const response: any = roomId
        ? await postVendorPropertyRoomImages({ imageData: formData, propertyId, roomId })
        : await postVendorPropertyImages({ imageData: formData, propertyId });
      if (response?.success) return { success: true, data: response.data, message: response?.message };
      const errorMessage = response?.message || "Failed to upload photos";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    } catch (error: any) {
      const errorMessage = error?.message || "An error occurred while uploading photos";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const updatePropertyImage =
  ({ propertyId, imageId, imageData }: any) => async (dispatch: any) => {
    try {
      const response: any = await putPropertyImage({ propertyId, imageId, imageData });
      if (response?.success) return { success: true, data: response.data, message: response?.message };
      const errorMessage = response?.message || "Failed to update photo";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    } catch (error: any) {
      const errorMessage = error?.message || "An error occurred while updating photo";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const removePropertyImage =
  ({ propertyId, imageId }: any) => async (dispatch: any) => {
    try {
      const response: any = await deletePropertyImage({ propertyId, imageId });
      if (response?.success) return { success: true, message: response?.message };
      const errorMessage = response?.message || "Failed to delete photo";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    } catch (error: any) {
      const errorMessage = error?.message || "An error occurred while deleting photo";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const fetchPropertyAmenitiesDetail =
  (propertyId: number | string) => async (_dispatch: any) => {
    try {
      const response: any = await getPropertyAmenitiesDetail(propertyId);
      return { success: true, data: response };
    } catch (error: any) {
      return { success: false, error: error?.message || "Failed to fetch property amenities" };
    }
  };

export const fetchPropertyRoomsList =
  (propertyId: number | string) => async (_dispatch: any) => {
    try {
      const response: any = await getPropertyRoomsList(propertyId);
      return { success: true, data: response };
    } catch (error: any) {
      return { success: false, error: error?.message || "Failed to fetch property rooms" };
    }
  };

export const fetchRoomAmenitiesDetail =
  (roomId: number | string) => async (_dispatch: any) => {
    try {
      const response: any = await getRoomAmenitiesDetail(roomId);
      return { success: true, data: response };
    } catch (error: any) {
      return { success: false, error: error?.message || "Failed to fetch room amenities" };
    }
  };

export const saveRoomAvailability =
  (roomId: number | string, payload: object) => async (_dispatch: any) => {
    try {
      const response: any = await setRoomAvailability(roomId, payload);
      if (response && response.success) {
        return { success: true, data: response.data };
      }
      return { success: false, error: response?.message || "Failed to save availability" };
    } catch (error: any) {
      return { success: false, error: error?.message || "Failed to save availability" };
    }
  };

export const fetchPropertyTodayActivity =
  (propertyId: number | string) => async (_dispatch: any) => {
    try {
      const response: any = await getVendorPropertyTodayActivity(propertyId);
      return { success: true, data: response };
    } catch (error: any) {
      return { success: false, error: error?.message || "Failed to fetch today activity" };
    }
  };

export const fetchRoomTypes = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));

    const response: any = await getRoomTypes();

    if (response && response.success) {
      dispatch(getRoomTypesSuccess(response.data));
    } else {
      dispatch(apiError("Failed to fetch room types"));
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "An error occurred while fetching room types";
    dispatch(apiError(errorMessage));
  }
};

export const fetchRoomAmenities = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));

    const response: any = await getRoomAmenities();

    if (response && response.success) {
      dispatch(getRoomAmenitiesSuccess(response.data));
    } else {
      dispatch(apiError("Failed to fetch room amenities"));
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "An error occurred while fetching room amenities";
    dispatch(apiError(errorMessage));
  }
};

export const createVendorProperty =
  (propertyData: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));

      const response: any = await postVendorProperties(propertyData);

      if (response && response.success) {
        dispatch(postVendorPropertiesSuccess(response.data));
        // Optionally refresh the dashboard after creating a property
        //dispatch(fetchVendorDashboard());
        return { success: true, data: response.data };
      } else {
        const errorMessage = response?.message || "Failed to create property";
        dispatch(apiError(errorMessage));
        return { success: false, error: errorMessage };
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred while creating property";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const createVendorPropertyPolicies =
  ({policiesData, propertyId}: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));

      const response: any = await postVendorPropertiesPolicies({policiesData, propertyId});

      if (response && response.success) {
        // FIX: Use postVendorPropertiesPoliciesSuccess instead of postVendorPropertiesSuccess
        dispatch(postVendorPropertiesPoliciesSuccess(response.data));
        return { success: true, data: response.data };
      } else {
        const errorMessage = response?.message || "Failed to create policies";
        dispatch(apiError(errorMessage));
        return { success: false, error: errorMessage };
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred while creating policies";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };;

export const createVendorPropertyTaxesFees =
  ({ taxesFeesData, propertyId }: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));

      const response: any = await postVendorPropertyTaxesFees({ taxesFeesData, propertyId });

      if (response && response.success) {
        return { success: true, data: response.data };
      } else {
        const errorMessage = response?.message || "Failed to save taxes and fees";
        dispatch(apiError(errorMessage));
        return { success: false, error: errorMessage };
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred while saving taxes and fees";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const createVendorPropertyServices =
  ({ servicesData, propertyId }: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));

      const response: any = await postVendorPropertyServices({ servicesData, propertyId });

      if (response && response.success) {
        return { success: true, data: response.data };
      } else {
        const errorMessage = response?.message || "Failed to save guest services";
        dispatch(apiError(errorMessage));
        return { success: false, error: errorMessage };
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred while saving guest services";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const createVendorPropertyRoom =
  ({ roomData, propertyId }: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));

      const response: any = await postVendorPropertyRoom({ roomData, propertyId });

      if (response && response.success) {
        return { success: true, data: response.data, message: response?.message };
      } else {
        const errorMessage = response?.message || "Failed to create room";
        dispatch(apiError(errorMessage));
        return { success: false, error: errorMessage };
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred while creating room";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const createVendorPropertyAmenities =
  ({amenitiesData, propertyId}: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));

      const response: any = await postVendorPropertiesAmenities({amenitiesData, propertyId});

      if (response && response.success) {
        dispatch(postVendorPropertiesAmenitiesSuccess(response.data));
        // Optionally refresh the dashboard after creating a property
        //dispatch(fetchVendorDashboard());
        return { success: true, data: response.data };
      } else {
        const errorMessage = response?.message || "Failed to create property";
        dispatch(apiError(errorMessage));
        return { success: false, error: errorMessage };
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred while creating property";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const createVendorRoomAmenities =
  ({ amenitiesData, roomId }: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));

      const response: any = await postVendorRoomAmenities({ amenitiesData, roomId });

      if (response && response.success) {
        dispatch(postVendorRoomAmenitiesSuccess(response.data));
        return { success: true, data: response.data };
      } else {
        const errorMessage = response?.message || "Failed to create room amenities";
        dispatch(apiError(errorMessage));
        return { success: false, error: errorMessage };
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred while creating room amenities";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const resetVendorFlags = () => async (dispatch: any) => {
  try {
    dispatch(resetVendorFlag());
  } catch (error: any) {
    dispatch(apiError(error));
  }
};

export const resetPropertyCreationState = () => async (dispatch: any) => {
  try {
    dispatch(resetPropertyCreation());
  } catch (error: any) {
    dispatch(apiError(error));
  }
};

export const updateVendorProperty =
  (propertyData: any, propertyId: any) => async (dispatch: any) => {
    try {
      const response: any = await putVendorProperty({ propertyData, propertyId });
      if (response && response.success) {
        return { success: true, data: response.data };
      }
      const errorMessage = response?.message || "Failed to update property";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    } catch (error: any) {
      const errorMessage = error?.message || "An error occurred while updating property";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const updateVendorPropertyPolicies =
  ({ policiesData, propertyId }: any) => async (dispatch: any) => {
    try {
      const response: any = await putVendorPropertiesPolicies({ policiesData, propertyId });
      if (response && response.success) {
        return { success: true, data: response.data };
      }
      const errorMessage = response?.message || "Failed to update policies";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    } catch (error: any) {
      const errorMessage = error?.message || "An error occurred while updating policies";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const updateVendorPropertyAmenities =
  ({ amenitiesData, propertyId }: any) => async (dispatch: any) => {
    try {
      const response: any = await putVendorPropertiesAmenities({ amenitiesData, propertyId });
      if (response && response.success) {
        return { success: true, data: response.data, message: response?.message };
      }
      const errorMessage = response?.message || "Failed to update amenities";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    } catch (error: any) {
      const errorMessage = error?.message || "An error occurred while updating amenities";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const updateVendorPropertyServices =
  ({ servicesData, propertyId }: any) => async (dispatch: any) => {
    try {
      const response: any = await putVendorPropertyServices({ servicesData, propertyId });
      if (response && response.success) {
        return { success: true, data: response.data };
      }
      const errorMessage = response?.message || "Failed to update guest services";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    } catch (error: any) {
      const errorMessage = error?.message || "An error occurred while updating guest services";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const updateVendorPropertyTaxesFees =
  ({ taxesFeesData, propertyId }: any) => async (dispatch: any) => {
    try {
      const response: any = await putVendorPropertyTaxesFees({ taxesFeesData, propertyId });
      if (response && response.success) {
        return { success: true, data: response.data };
      }
      const errorMessage = response?.message || "Failed to update taxes and fees";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    } catch (error: any) {
      const errorMessage = error?.message || "An error occurred while updating taxes and fees";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const updateVendorPropertyRoom =
  ({ roomData, propertyId, roomId }: any) => async (dispatch: any) => {
    try {
      const response: any = await putVendorPropertyRoom({ roomData, propertyId, roomId });
      if (response && response.success) {
        return { success: true, data: response.data, message: response?.message };
      }
      const errorMessage = response?.message || "Failed to update room";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    } catch (error: any) {
      const errorMessage = error?.message || "An error occurred while updating room";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };

export const updateVendorRoomAmenities =
  ({ amenitiesData, roomId }: any) => async (dispatch: any) => {
    try {
      const response: any = await putVendorRoomAmenities({ amenitiesData, roomId });
      if (response && response.success) {
        return { success: true, data: response.data, message: response?.message };
      }
      const errorMessage = response?.message || "Failed to update room amenities";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    } catch (error: any) {
      const errorMessage = error?.message || "An error occurred while updating room amenities";
      dispatch(apiError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };
